import { createReducer } from '@reduxjs/toolkit';

import { fetchEntitySuccess } from 'modules/entity/actions';
import { FETCH_MESSAGES_SUCCESS, FETCH_NEXT_MESSAGES_SUCCESS } from 'modules/chat/actionTypes';

/**
 * @typedef {string | null} GetNextMessagesUrlState
 */

/** @type {GetNextMessagesUrlState} */
const initialState = null;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(fetchEntitySuccess, () => null)
    .addCase(FETCH_MESSAGES_SUCCESS, (_, { payload }) => payload.getNextMessagesUrl)
    .addCase(FETCH_NEXT_MESSAGES_SUCCESS, (_, { payload }) => payload.getNextMessagesUrl);
});
